/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {EntitlementResource} from '../models/EntitlementResource';
import type {Error} from '../models/Error';
import type {ResourceList} from '../models/ResourceList';

export interface GetProductResourcesByIds$Request {
    requestBody: Array<string>;
}

export interface GetProductResourcesByIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductResourcesByIdsRequest = createAction<PayloadData<void, GetProductResourcesByIds$Request>>('PRODUCT_ENTITLEMENTS_RESOURCE__GET_PRODUCT_RESOURCES_BY_IDS__REQUEST');
export const getProductResourcesByIdsSuccess = createAction<PayloadData<{ [key: string]: EntitlementResource; }, GetProductResourcesByIds$Request>>('PRODUCT_ENTITLEMENTS_RESOURCE__GET_PRODUCT_RESOURCES_BY_IDS__SUCCESS');
export const getProductResourcesByIdsFailure = createAction<PayloadData<Error, GetProductResourcesByIds$Request, true>>('PRODUCT_ENTITLEMENTS_RESOURCE__GET_PRODUCT_RESOURCES_BY_IDS__FAILURE');

export const getProductResourcesByIdsActions = [
    getProductResourcesByIdsRequest,
    getProductResourcesByIdsSuccess,
    getProductResourcesByIdsFailure
] as const;

/**
 * @param {Array<string>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductResourcesByIds = (meta: GetProductResourcesByIds$Request, config?: GetProductResourcesByIds$Config) => {
    return {
        CALL_API: {
            types: getProductResourcesByIdsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/product/entitlements/resources`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetProductResourcesWithoutRelations$Request {
    pageSize: number;
    pageNumber: number;
    namespace: string;
}

export interface GetProductResourcesWithoutRelations$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getProductResourcesWithoutRelationsRequest = createAction<PayloadData<void, GetProductResourcesWithoutRelations$Request>>('PRODUCT_ENTITLEMENTS_RESOURCE__GET_PRODUCT_RESOURCES_WITHOUT_RELATIONS__REQUEST');
export const getProductResourcesWithoutRelationsSuccess = createAction<PayloadData<ResourceList, GetProductResourcesWithoutRelations$Request>>('PRODUCT_ENTITLEMENTS_RESOURCE__GET_PRODUCT_RESOURCES_WITHOUT_RELATIONS__SUCCESS');
export const getProductResourcesWithoutRelationsFailure = createAction<PayloadData<Error, GetProductResourcesWithoutRelations$Request, true>>('PRODUCT_ENTITLEMENTS_RESOURCE__GET_PRODUCT_RESOURCES_WITHOUT_RELATIONS__FAILURE');

export const getProductResourcesWithoutRelationsActions = [
    getProductResourcesWithoutRelationsRequest,
    getProductResourcesWithoutRelationsSuccess,
    getProductResourcesWithoutRelationsFailure
] as const;

/**
 * @param {number} meta.pageSize
 * @param {number} meta.pageNumber
 * @param {string} meta.namespace
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getProductResourcesWithoutRelations = (meta: GetProductResourcesWithoutRelations$Request, config?: GetProductResourcesWithoutRelations$Config) => {
    const TRANSPORT_GET_PARAMS = {
        pageSize: meta.pageSize,
        pageNumber: meta.pageNumber,
        namespace: meta.namespace,
    };
    return {
        CALL_API: {
            types: getProductResourcesWithoutRelationsActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/product/entitlements/resources`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

